import { requirePermission } from "@lib/permissions/guards";
import { PERMISSIONS } from "@lib/permissions/permissions.generated";
import { createFileRoute } from "@tanstack/react-router";
import { Eye } from "lucide-react";
import { NoteDeFraisView } from "@/features/rh/notes-de-frais/components/NoteDeFraisView";

export const Route = createFileRoute("/_app/rh/notes-de-frais/$id/view")({
  loader: requirePermission(PERMISSIONS.RH.FRAIS?.VIEW || "rh.frais.view"),
  staticData: {
    title: "Voir une note de frais",
    icon: Eye,
    permission: PERMISSIONS.RH.FRAIS?.VIEW || "rh.frais.view",
    section: "App",
    showInBreadcrumb: true,
  },
  component: NoteDeFraisView,
});
